<template>
  <g stroke="null" fill-rule="evenodd" fill="none">
    <path d="M.031.031H19.97V19.97H.03V.03z" />
    <path
      d="M16.813 2.025h-.997V.031h-1.994v1.994H5.847V.031H3.853v1.994h-.996A1.985 1.985 0 00.873 4.02l-.01 13.956c0 1.096.887 1.994 1.994 1.994h13.956a2 2 0 001.993-1.994V4.019a2 2 0 00-1.993-1.994zm0 15.95H2.857V7.009h13.956v10.966z"
      fill-rule="nonzero"
      :fill="color"
    />
  </g>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      required: true
    }
  }
};
</script>
